import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { TranslationProvider } from './lang/TranslationContext';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<TranslationProvider>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</TranslationProvider>
		</QueryClientProvider>
	</React.StrictMode>
);
